import React from 'react';
import PropTypes from 'prop-types';
import { recommendationShape } from '@bibliocommons/bc-prop-types';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { recommendationComposer } from '@bibliocommons/analytics-event-composers';
import VendorAttributionLabel from 'app/components/bibs/shared/VendorAttributionLabel';
import { BibSlideContainer } from 'app/components/bibs/shared/BibSlide';

import './RecommendationItem.scss';

const { composeImageClickEvent } = recommendationComposer;

function handleClick(item) {
  const providerURI = item.get('providerURI');
  const metadataId = item.get('id');
  sendAnalyticsEvents(
    composeImageClickEvent({
      providerURI,
      metadataId
    })
  );
}

export default function RecommendationItem({ item, itemIndex }) {
  function renderAttribution() {
    return (
      <div className="provider-label">
        {itemIndex === 0 && <VendorAttributionLabel name={item.get('providerName')} />}
      </div>
    );
  }

  return (
    <BibSlideContainer
      className="cp-bib-recommendation-item"
      metadataId={item.get('id')}
      renderAttribution={renderAttribution}
      handleClick={() => handleClick(item)}
    />
  );
}

RecommendationItem.propTypes = {
  item: recommendationShape.isRequired,
  itemIndex: PropTypes.number.isRequired
};
